module.exports = __webpack_public_path__ + "img/mounted-guns.f35588a8.webp";